<template>
  <div class="wrapper">
    <side-bar>
      <div v-if="isLogged" class="pl-2em pb-2 text-body">
        Olá, {{ getGreeting }}!
      </div>
      <sidebar-link to="/portal/home" v-if="!isLogged">
        <i class="nc-icon nc-chart-pie-35"></i>
        <p>Início</p>
      </sidebar-link>
      <sidebar-link to="/portal/sobre-nos" v-if="!isLogged">
        <i class="fa fa-sun-o"></i>
        <p>Empresa</p>
      </sidebar-link>
      <sidebar-link to="/portal/solucoes" v-if="!isLogged">
        <i class="fa fa-check-circle-o"></i>
        <p>Soluções</p>
      </sidebar-link>
      <sidebar-link to="/portal/perto-de-voce" v-if="!isLogged">
        <i class="fa fa-map-marker"></i>
        <p>Perto de Você</p>
      </sidebar-link>
      <sidebar-link to="/portal/sua-usina" v-if="!isLogged">
        <i class="fa fa-calculator"></i>
        <p>Sua Usina</p>
      </sidebar-link>
      <sidebar-link to="/portal/produtos">
        <i class="fa fa-shopping-cart"></i>
        <p>Loja</p>
      </sidebar-link>
      <sidebar-link to="/portal/login" v-if="!isLogged">
        <i class="nc-icon nc-circle-09"></i>
        <p>Login</p>
      </sidebar-link>
      <sidebar-link to="/portal/perfil" v-if="false">
        <i class="nc-icon nc-badge"></i>
        <p>Perfil 2.0</p>
      </sidebar-link>
      <sidebar-link to="/portal/perfil" v-if="isLogged">
        <i class="nc-icon nc-badge"></i>
        <p>Perfil</p>
      </sidebar-link>
      <sidebar-link
        to="/portal/controle-anuncios"
        v-if="canLoggedUserUseIt('colaborador')"
      >
        <i class="nc-icon nc-tv-2"></i>
        <p>Controle Anúncios</p>
      </sidebar-link>
      <sidebar-link
        to="/portal/controle-concessionarias"
        v-if="canLoggedUserUseIt('colaborador')"
      >
        <i class="fa fa-building-o"></i>
        <p>Controle Concessionárias</p>
      </sidebar-link>
      <sidebar-link
        to="/portal/controle-usuarios"
        v-if="canLoggedUserUseIt('colaborador')"
      >
        <i class="nc-icon nc-single-02"></i>
        <p>Controle Usuários</p>
      </sidebar-link>
      <sidebar-link
        to="/portal/controle-produtos"
        v-if="canLoggedUserUseIt('colaborador')"
      >
        <i class="fa fa-product-hunt align-self-center"></i>
        <p>Controle Produtos</p>
      </sidebar-link>
      <sidebar-link
        to="/portal/controle-responsavel-estado"
        v-if="canLoggedUserUseIt('colaborador')"
      >
        <i class="fa fa-product-hunt align-self-center"></i>
        <p>Controle Responsaveis por Estado</p>
      </sidebar-link>

      <sidebar-link to="/portal/servicos" v-if="canLoggedUserUseIt('parceiro')">
        <i class="nc-icon nc-cart-simple"></i>
        <p>Serviços</p>
      </sidebar-link>
      <sidebar-link
        to="/portal/cadastrar-proposta"
        v-if="canLoggedUserUseIt('vendedor')"
      >
        <i class="nc-icon nc-single-copy-04"></i>
        <p>Cadastrar Proposta</p>
      </sidebar-link>
      <sidebar-link
        to="/portal/historico-propostas"
        v-if="canLoggedUserUseIt('colaborador')"
      >
        <i class="fa fa-clock-o align-self-center"></i>
        <p>Propostas Geradas</p>
      </sidebar-link>
      <sidebar-link
        to="/portal/clientes"
        v-if="canLoggedUserUseIt('colaborador')"
      >
        <i class="fa fa-user-plus"></i>
        <p>CLIENTES</p>
      </sidebar-link>
      <sidebar-link
        to="/portal/financeiro-geral"
        v-if="canLoggedUserUseIt('administrador')"
      >
        <i class="nc-icon nc-money-coins"></i>
        <p>Financeiro Geral</p>
      </sidebar-link>
      <sidebar-link
        to="/portal/controle-os"
        v-if="canLoggedUserUseIt('colaborador')"
      >
        <i class="fa fa-file-text"></i>
        <p>Ordem de Serviço</p>
      </sidebar-link>
      <sidebar-link to="/portal/crm" v-if="canLoggedUserUseIt('vendedor')">
        <i class="fa fa-rocket"></i>
        <p>CRM</p>
      </sidebar-link>
      <sidebar-link
        to="/portal/vendedores"
        v-if="canLoggedUserUseIt('administrador')"
      >
        <i class="fa fa-users"></i>
        <p>Vendedores</p>
      </sidebar-link>
      <sidebar-link to="/portal/downloads" v-if="isLogged">
        <i class="nc-icon nc-cloud-download-93"></i>
        <p>Downloads</p>
      </sidebar-link>
      <sidebar-link
        to="/portal/parceiros"
        v-if="canLoggedUserUseIt('administrador')"
      >
        <i class="fa fa-handshake-o"></i>
        <p>Parceiros</p>
      </sidebar-link>
      <sidebar-link
        to="/portal/bugfix"
        v-if="isLogged"
        hide="true"
      ></sidebar-link>
      <sidebar-link
        to="/portal/bugfix"
        v-if="isLogged"
        hide="true"
      ></sidebar-link>
      <sidebar-link
        to="/portal/bugfix"
        v-if="isLogged"
        hide="true"
      ></sidebar-link>
      <sidebar-link
        to="/portal/bugfix"
        v-if="isLogged"
        hide="true"
      ></sidebar-link>
      <sidebar-link
        to="/portal/bugfix"
        v-if="isLogged"
        hide="true"
      ></sidebar-link>
      <sidebar-link
        to="/portal/bugfix"
        v-if="isLogged"
        hide="true"
      ></sidebar-link>
      <sidebar-link
        to="/portal/bugfix"
        v-if="isLogged"
        hide="true"
      ></sidebar-link>
      <sidebar-link
        to="/portal/bugfix"
        v-if="isLogged"
        hide="true"
      ></sidebar-link>
      <sidebar-link
        to="/portal/bugfix"
        v-if="isLogged"
        hide="true"
      ></sidebar-link>

      <template slot="bottom-links">
        <div class="d-flex justify-content-center">
          <a href="https://wa.me/5581995212354" class="mr-4"
            ><i
              class="fa fa-whatsapp fa-2x bottom-icons-style"
              aria-hidden="true"
            ></i
          ></a>
          <a
            class="mr-4"
            href="https://instagram.com/jouleenergiasolar?igshid=rl8j035gycbe"
            ><i
              class="fa fa-instagram fa-2x bottom-icons-style"
              aria-hidden="true"
            ></i
          ></a>
          <a class="mr-4" href="https://www.facebook.com/joule.eco/"
            ><i
              class="fa fa-facebook-square fa-2x bottom-icons-style"
              aria-hidden="true"
            ></i
          ></a>
          <a
            class="mr-4"
            href="https://www.youtube.com/channel/UCgfgzDXgX3AovpQz6_L2OsQ"
            ><i
              class="fa fa-youtube-play fa-2x bottom-icons-style"
              aria-hidden="true"
            ></i
          ></a>
        </div>
        <div class="bottom-text-style">
          <br />
          <p>
            <b>Joule Energia Solar</b>
          </p>
          <p>
            <b>
              Rua Jornalista José Ramalho, n° 33, Costa e Silva, João Pessoa -
              PB,
              <br />CEP: 58.081-110 <br />CNPJ: 31.012.459/0001-39
            </b>
          </p>
        </div>

        <button
          type="button"
          v-if="isLogged"
          class="btn btn-link logout-btn"
          @click.prevent
          @click="logout"
        >
          Sair
        </button>
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>
      <dashboard-content @click="toggleSidebar"></dashboard-content>
    </div>
  </div>
</template>
<style lang="scss"></style>
<script>
import _ from 'lodash';
import TopNavbar from './TopNavbar.vue';
import DashboardContent from './Content.vue';

export default {
  components: {
    TopNavbar,
    DashboardContent
  },
  data() {
    return {
      email: ''
    };
  },
  created() {
    if (localStorage.getItem('userData')) {
      this.$store.commit(
        'SAVE_USUARIO',
        JSON.parse(localStorage.getItem('userData'))
      );
    }
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    logout() {
      localStorage.removeItem('userData');
      this.$store.commit('LOGOUT');
      this.$router.replace('home');
    },
    getUserData() {
      return this.$store.state.usuario;
    },
    notifyVue(verticalAlign, horizontalAlign, type, message, icon) {
      this.$notifications.notify({
        message: `<span>${message}.</span>`,
        icon: icon,
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type
      });
    },
    /*
      hierarquia tipo de usuario:
          ADMINSTRADOR
          COLABORADOR
      VENDEDOR | PARCEIRO
    */
    canLoggedUserUseIt(tipoUsuarioNecessario) {
      if (this.isLogged) {
        const userData = this.$store.state.usuario;
        if (_.get(userData, 'tipoUsuario') === 'administrador') {
          return true;
        }
        if (_.get(userData, 'tipoUsuario') === 'colaborador') {
          if (tipoUsuarioNecessario === 'administrador') {
            return false;
          }
          return true;
        }
        if (_.get(userData, 'tipoUsuario') === tipoUsuarioNecessario) {
          return true;
        }
        return false;
      }
      return false;
    }
  },
  computed: {
    isLogged() {
      return this.$store.state.usuario && this.$store.state.usuario.tipoUsuario;
    },
    getGreeting() {
      return this.$store.state.usuario.tipoParceiro === 'pf'
        ? `${this.$store.state.usuario.nome} ${this.$store.state.usuario.sobrenome}`
        : `${this.$store.state.usuario.razaoSocial}`;
    }
  }
};
</script>
<style>
.pl-2em {
  padding-left: 2em;
}

.nav-bottom {
  text-align: center;
}

.bottom-icons-position {
  top: 50%;
  left: 50%;
}
.bottom-text-style {
  color: black;
}
.bottom-icons-style {
  color: black;
}
.bottom-icons-style:hover {
  color: gray;
}
</style>
